import React, { FunctionComponent } from 'react'
import { Text } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import styles from './style.module.css'

interface ToastMessageProps {
  onGotIt: () => void
  onOptOut: () => void
}

/**
 * CASHDAP-3292: content of the first-time remember-me issuance toast. Core Toast has no built-in
 * action buttons, so the two tappable actions are rendered inside the message: "Not on this device"
 * (opt out — this device is never remembered again) and "Got it" (acknowledge).
 */
export const ToastMessage: FunctionComponent<ToastMessageProps> = ({ onGotIt, onOptOut }) => {
  const { t } = useTranslation()
  return (
    <>
      <Text size='M' bold testNameSpace='auto-remember-me-issuance-toast-heading'>
        {t('common:rememberMeToastTitle')}
      </Text>
      <Text size='XS' testNameSpace='auto-remember-me-issuance-toast-body'>
        {t('common:rememberMeToastBody')}
      </Text>
      <div className={styles.actions}>
        <button type='button' className={styles.optOut} onClick={onOptOut} data-testid='auto-remember-me-issuance-toast-opt-out'>
          {t('common:rememberMeToastNotOnThisDevice')}
        </button>
        <button type='button' className={styles.gotIt} onClick={onGotIt} data-testid='auto-remember-me-issuance-toast-got-it'>
          {t('common:rememberMeToastGotIt')}
        </button>
      </div>
    </>
  )
}
